import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { ApiService } from '../../../../services/api.service';

@Component({
  selector: 'app-elimina-live-backoffice',
  templateUrl: './elimina-live-backoffice.component.html',
  styleUrls: ['./elimina-live-backoffice.component.css']
})
export class EliminaLiveBackofficeComponent {

  constructor(private apiService: ApiService) { }

  loading: boolean = false;

  readonly #modal = inject(NzModalRef);
  readonly nzModalData = inject(NZ_MODAL_DATA);

  onElimina() {
    this.loading = true;

    // Elimino il live
    this.apiService.deleteLive(this.nzModalData.id_live!).subscribe({
      next: (data) => this.apiService.setLive(),
      error: (err) => {
        this.loading = false;
        this.apiService.error(err.error.message);
      },
      complete: () => {
        this.loading = false;
        this.#modal.destroy();
      }
    })

  }
  onClose() {
    this.#modal.destroy();
  }

}